import jwtDecode from "jwt-decode";
import { createContext, useCallback, useContext, useState } from "react";
import IUserContext from "../../interfaces/context/userContext";

import { Roles } from "../../interfaces/editor/rolesEnum";

import { IUserData } from "../../interfaces/editor/userData";

const UserContext = createContext<IUserContext | undefined>(undefined);

const UserContextProvider = (props: { children: JSX.Element }) => {
  // Verifica token do usuario, se ainda é valido ou não
  const handleIsLoggedIn = () => {
    if (typeof window !== "undefined") {
      const jwtToken = sessionStorage.getItem("tokenJwt");
      if (!jwtToken) return false;
      // const { exp } = jwtDecode(jwtToken)
      // return (Date.now() <= exp * 1000)
    }
    return false;
  };

  function getUserData(): IUserData {
    if (typeof window !== "undefined") {
      const jwtToken = sessionStorage.getItem("tokenJwt");
      if (!jwtToken)
        return {
          unique_name: "",
          email: "",
          atualizar_senha: "False",
          idUsuario: 0,
          admin: false,
          role: [],
        };
      return jwtDecode<IUserData>(sessionStorage.getItem("tokenJwt") || "");
    }

    return {
      unique_name: "",
      email: "",
      atualizar_senha: "False",
      idUsuario: 0,
      admin: false,
      role: [],
    };
  }

  const isUserAdmin = () => {
    return false;
  };

  const [usuarioLogado, setUsuarioLogado] = useState<boolean>(handleIsLoggedIn());
  const [userData, setUserData] = useState<IUserData>(getUserData());
  const [userJwt, setUserJwt] = useState<string | null>(() => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("tokenJwt");
    } else {
      return "";
    }
  });

  const isUserInRole = useCallback(
    (role: Roles) => {
      if (userData.role) {
        return userData.role.includes(role);
      }
      return false;
    },
    [userData],
  );

  const login = useCallback((jwtPayload: IUserData) => {
    setUsuarioLogado(true);
    setUserData(jwtPayload);
  }, []);

  const logoff = useCallback(() => {
    setUsuarioLogado(false);
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("tokenJwt");
    }
  }, []);

  const clearJwt = useCallback(() => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("tokenJwt");
    }
  }, []);

  const setJwt = useCallback((jwt: string | null) => {
    if (jwt && typeof window !== "undefined") {
      sessionStorage.setItem("tokenJwt", jwt);
      setUserJwt(jwt);
    }
  }, []);

  const data: IUserContext = {
    usuarioLogado,
    login,
    logoff,
    clearJwt,
    userJwt,
    setJwt,
    userData,
    isUserAdmin,
    isUserInRole,
  };

  return <UserContext.Provider value={data}>{props.children}</UserContext.Provider>;
};

const useUserContext = () => {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error("useUserContext must be used within a UserContextProvider");
  }

  return context;
};

export { useUserContext };

export default UserContextProvider;
